import useClipboard from 'vue-clipboard3';

export function createId(len = 6) {
    var now = new Date();
    var dateString = now.getFullYear() + "" + (now.getMonth() + 1) + "" + now.getDate() + "" + now.getHours() + "" + now.getMinutes() + "" + now.getSeconds() + "-";
    let str = '';
    for (let i = 0; i <= Math.floor(len / 6); i++) {
        str += Math.random().toString(36).slice(2, 8).toUpperCase();
    }
    return dateString + str.slice(0, len);
};

/**
 * Created by PanJiaChen on 16/11/18.
 */
/**
 * 获取中文字符串长度
 */
export function getGbStringLength(str) {
    str = str || "";
    var char = str.match(/[^\x00-\xff]/ig);
    return str.length + (char == null ? 0 : char.length);
}
// // 英文占1个字符，中文汉字占2个字符
// function getGbStringLength(str) { // eslint-disable-line
//     let len = 0;
//     for (let i = 0; i < str.length; i++) {
//         if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
//             len += 2;
//         } else {
//             len++;
//         }
//     }
//     return len;
// }


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
    if (!search) {
        return {}
    }
    const obj = {}
    const searchArr = search.split('&')
    searchArr.forEach(v => {
        const index = v.indexOf('=')
        if (index !== -1) {
            const name = v.substring(0, index)
            const val = v.substring(index + 1, v.length)
            obj[name] = val
        }
    })
    return obj
}

/**
 * 复制元素
 */
export function deepClone(obj) {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                //判断ojb子元素是否为对象，如果是，递归复制
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    //如果不是，简单复制
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
};

/**
   * @desc 函数防抖:返回一个函数，短时间内多次触发调用，只执行最后一次，或者只执行最开始的一次，中间的不执行。
   * @param func 目标函数
   * @param wait 延迟执行毫秒数
   * @param immediate true - 立即执行， false - 延迟执行
   * 返回一个防抖函数
   */
export function debounce(func, wait, immediate) {
    let timer;
    return function () {
        let context = this,
            args = arguments;

        if (timer) clearTimeout(timer);
        if (immediate) {
            let callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, wait);
            if (callNow) func.apply(context, args);
        } else {
            timer = setTimeout(() => {
                func.apply(context, args);
            }, wait)
        }
    }
}
///* 测试 */
// var fun = debounce(console.log.bind(console,"执行"),1000,0);
// new Array(30).fill(0).forEach((s,i)=>setTimeout((k=>{
//     console.log(k);
//     fun(k);
// }).bind(null,i),i*300))

/**
   * @desc 防抖调用:短时间内多次触发，如果调用key相同，只执行最后一次func，或者只执行最开始的一次func，中间的不执行。
   * @param func 目标函数
   * @param wait 延迟执行毫秒数
   * @param immediate true - 立即执行， false - 延迟执行
   * 返回一个防抖函数
   */
export function debounceCall(key, func, wait, immediate) {
    let timer = debounceCall[key];
    let context = this;

    if (timer) clearTimeout(timer);
    if (immediate) {
        let callNow = !timer;
        debounceCall[key] = setTimeout(() => {
            debounceCall[key] = null;
        }, wait);
        if (callNow) func.call(context);
    } else {
        debounceCall[key] = setTimeout(() => {
            func.call(context);
        }, wait)
    }
}
///* 测试 */
// new Array(30).fill(0).forEach((s,i)=>setTimeout((k=>{
//     console.log(k);
//     debounceCall('test',console.log.bind(console,"执行",k),1000,1)
// }).bind(null,i),i*300))

//https://www.cnblogs.com/cc-freiheit/p/10827372.html
/**
 * @desc 函数节流:指连续触发事件但是在 n 秒中只执行一次函数。即会稀释函数的执行频率。
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 表时间戳版，2 表定时器版
 * 时间戳版和定时器版的节流函数的区别就是，时间戳版的函数触发是在时间段内开始的时候，而定时器版的函数触发是在时间段内结束的时候
 * 表时间戳版:触发间隔大于wait（延迟时间），则执行
 * 定时器版：定时wait（延迟时间）后执行
 */
// export function throttle(func, wait, type) {
//     if (type === 1) {
//         var previous = 0;
//         return function () {
//             let context = this;
//             let args = arguments;
//             let now = Date.now();
//             if (now - previous > wait) {
//                 func.apply(context, args);
//                 previous = now;
//             }
//         }
//     } else if (type === 2) {
//         var timeout;
//         return function () {
//             let context = this;
//             let args = arguments;
//             if (!timeout) {
//                 timeout = setTimeout(() => {
//                     timeout = null;
//                     func.apply(context, args)
//                 }, wait)
//             }
//         }
//     }
// }
/**
 * @desc 函数节流:指连续触发事件但是在 n 秒中只执行一次函数。即会稀释函数的执行频率。
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param startSun 开始是否立即执行
 */
export function throttle(func, wait, startSun) {
    var timeout;
    var lastCall;
    return function () {
        let context = this;
        let args = arguments;
        if (!timeout) {
            if (startSun) {
                func.apply(context, args);
            } else {
                lastCall = func.bind.apply(func, [context].concat([].slice.call(args, 0)));
            }
            timeout = setInterval(() => {
                if (lastCall) {
                    lastCall();
                    lastCall = null;
                } else {
                    clearInterval(timeout);
                    timeout = null;
                }
            }, wait)
        } else {
            lastCall = func.bind.apply(func, [context].concat([].slice.call(args, 0)));
        }

    }
}
// var fun = throttle(console.log.bind(console,"执行"),1000,1);
// new Array(30).fill(0).forEach((s,i)=>setTimeout((k=>{
//     console.log(k);
//     fun(k);
// }).bind(null,i),i*300))

/**
 * @desc 函数节流:指连续触发事件但是在 n 秒中只执行一次函数。即会稀释函数的执行频率。
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param startSun 开始是否立即执行
 */
export function throttleCall(key, func, wait, startSun) {
    if (!throttleCall[key]) {
        throttleCall[key] = {};
    }
    if (!throttleCall[key].timeout) {
        if (startSun) {
            func();
        } else {
            throttleCall[key].lastCall = func;
        }
        var obj = throttleCall[key];
        throttleCall[key].timeout = setInterval(() => {
            if (obj.lastCall) {
                obj.lastCall();
                obj.lastCall = null;
            } else {
                clearInterval(obj.timeout);
                obj.timeout = null;
            }
        }, wait)
    } else {
        throttleCall[key].lastCall = func;
    }
}
//测试
// new Array(30).fill(0).forEach((s,i)=>setTimeout((k=>{
//     console.log(k);
//     throttleCall('test',console.log.bind(console,"执行",k),1000,1);
// }).bind(null,i),i*300))

Promise.isPromise = Promise.isPromise || function (obj) {
    return obj && Object.prototype.toString.call(obj) === '[object Promise]'
    // return !!obj //有实际含义的变量才执行方法，变量null，undefined和''空串都为false
    //     &&
    //     (typeof obj === 'object' || typeof obj === 'function') // 初始promise 或 promise.then返回的
    //     &&
    //     typeof obj.then === 'function';
};
/**
* 实现一个带重试机制的函数
* @param {Function} func - 需要执行的函数
* @param {number} retries - 最大重试次数
* @param {number} delay - 每次重试之间的延迟时间（毫秒）
* @returns {Promise<any>} - 函数执行的结果
*/
export async function withRetry(func, retries = 3, delay = 1000) {
    if (!func) {
        return Promise.reject('func is not a function');
    }
    let attempt = 0;
    let result;

    while (attempt < retries) {
        try {
            result = await func();
            // 如果函数执行成功，返回结果
            return result;
        } catch (error) {
            // 如果函数执行失败，增加重试次数，并延迟一段时间后重试
            attempt++;
            if (attempt >= retries) {
                // 如果已经达到最大重试次数，抛出错误
                throw new Error(`Failed after ${retries} attempts: ${error.message}`);
            }
            if (delay > 0) {
                await new Promise((resolve) => setTimeout(resolve, delay));
            }
        }
    }
}

/////---复制文本
///////  npm install vue-clipboard3 --save
///////  import useClipboard from 'vue-clipboard3'

//复制字符串
const { toClipboard } = useClipboard();
export async function copy(text) {
    if(typeof text === 'undefined'){
        text = "";
    }
    try {
        await toClipboard('' + text)
        console.log('复制到剪切板')
    } catch (e) {
        console.error("复制出错", e)
        return Promise.reject(e);
    }
};


//查找最后一个符合条件的索引
export function findLastIndex(array, cb) {
	if (!Array.isArray(array)) {
		return -1;
	}
	if (array.length === 0) {
		return -1;
	}
	for (var i = array.length - 1; i >= 0; i--) {
		const item = array[i];
		if (cb.call(null, item, i, array)) {
			return i;
		}
	}
	return -1;
};
